import gql from 'graphql-tag';

export const GET_PLAN_UTILITY_ACCOUNTS_QUERY = gql`
  query GetPlanUtilityAccounts($planId: Int!) {
    plan(id: $planId) {
      id
      utilityAccounts {
        id
      }
    }
  }
`;

export const getPlanUtilityAccountsMock = {
  plan: {
    id: 1,
    utilityAccounts: [{ id: 1 }],
  },
};
